/**
 * The "what it certifies" rows for a product's registry category: the two
 * category-independent rows (the public criteria, reproducibility) around the
 * four that differ by category. An unknown category keeps certWhatRows, whose
 * wording is true for every category.
 */
export function certWhatRowsFor(t, category) {
  const middle = category && t.certWhatCategoryRows[category];
  if (!middle) return t.certWhatRows;
  const all = t.certWhatRows;
  return [all[0], ...middle, all[all.length - 1]];
}
